import React from 'react';
import { useParams, useLocation, navigate } from '@reach/router';
import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';
import { Box, Typography } from '@material-ui/core';
import UserTableList from './user-table-list';
import { ArrowBack } from '@material-ui/icons';
import { useSearchFilters } from '../../../lib/hooks/use-search-filters';
import { UserSearchFilters } from './user-search-filters';
import AlertDialog from '../../organisim/alert-dialog';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { FilterPanel } from './user-search-filters';
import { useIsMobile } from '../../../lib/hooks/use-is-mobile';
import { useDrawer } from '../../../lib/hooks/use-drawer';
import { colors } from '../../../config/theme';

const IconWrapper = styled.div`
  cursor: pointer;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.onPrimary};
  height: 50px;
  background: ${colors.primary};
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 0 16px;
  box-sizing: border-box;
`;

export const UserPromoSearch = ({
  invitees = [],
  handleAddInvitee,
  handleDeleteUserPromo,
  isDrawerOpen,
  toggleDrawer,
  handleCloseAlert = () => {},
  handleErrorMessage = () => {},
  showAlertError = { open: false, message: '' },
}) => {
  const {
    searchTerm,
    setSearchTerm,
    program,
    setProgram,
    handleProgramChange,
    startDate,
    handleStartDateChange,
    endDate,
    handleEndDateChange,
    lastPromoted,
    setLastPromoted,
  } = useSearchFilters();

  const { isMobile } = useIsMobile();
  const {
    isDrawerOpen: isFilterDrawerOpen,
    toggleDrawer: toggleFilterDrawer,
  } = useDrawer();

  const { gymUid } = useParams();
  const queryParams = new URLSearchParams(useLocation().search);
  const backUrl = queryParams.get('backUrl');

  const addInvitee = (user) => {
    handleAddInvitee(user);
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={toggleDrawer}
      BackdropProps={{ invisible: true }}
      PaperProps={{ style: { width: '100%', background: colors.surface } }}
      transitionDuration={{ enter: 350, exit: 300 }} // Adjust the animation duration (in milliseconds)
    >
      <div>
        <Header>
          <IconWrapper onClick={() => toggleDrawer('')}>
            <ArrowBack />
          </IconWrapper>
          <Typography variant="h6">{'Invitees'}</Typography>
          <div />
        </Header>
        <Box p="24px" style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <Box>
            <UserSearchFilters
              setSearchTerm={setSearchTerm}
              program={program}
              setProgram={setProgram}
              handleProgramChange={handleProgramChange}
              startDate={startDate}
              handleStartDateChange={handleStartDateChange}
              endDate={endDate}
              handleEndDateChange={handleEndDateChange}
              lastPromoted={lastPromoted}
              setLastPromoted={setLastPromoted}
              toggleFilterDrawer={toggleFilterDrawer}
              backTo={backUrl ? () => navigate(backUrl) : toggleDrawer}
            />
          </Box>
          <Box>
            <UserTableList
              filters={{
                program,
                startDate,
                endDate,
                lastPromoted,
              }}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              gymUid={gymUid}
              selectable={true}
              handleAddInvitee={addInvitee}
              handleDeleteUserPromo={handleDeleteUserPromo}
              invitees={invitees}
            />
          </Box>
        </Box>
        <AlertDialog
          title="Error adding invitee"
          message={showAlertError?.message}
          open={showAlertError?.open}
          handleAgree={handleCloseAlert}
          handleCancel={handleCloseAlert}
          buttonAgreeText="Ok"
          buttonCancelText="Close"
        />

        {isMobile && (
          <SwipeableDrawer
            anchor="bottom"
            open={isFilterDrawerOpen}
            onClose={toggleFilterDrawer}
            onOpen={() => {}}
            PaperProps={{
              style: {
                borderRadius: '20px 20px 0 0',
                minHeight: '30vh',
                background: colors.surface,
              },
            }}
            transitionDuration={{ enter: 300, exit: 250 }}
          >
            <Header>
              <IconWrapper onClick={() => toggleFilterDrawer('')}>
                <ArrowBack />
              </IconWrapper>
              <Typography variant="h6">{'Filters'}</Typography>
              <div />
            </Header>
            <Box p="24px">
              <FilterPanel
                program={program}
                setProgram={setProgram}
                handleProgramChange={handleProgramChange}
                startDate={startDate}
                handleStartDateChange={handleStartDateChange}
                endDate={endDate}
                handleEndDateChange={handleEndDateChange}
                lastPromoted={lastPromoted}
                setLastPromoted={setLastPromoted}
              />
            </Box>
          </SwipeableDrawer>
        )}
      </div>
    </Drawer>
  );
};

export default UserPromoSearch;
